import React from 'react';

export default class Row extends React.Component {
  render() {
    const row = this.props;
    return (
      <tr>
        <td>{row.name}</td>
        <td>{row.quantity}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SortableTable/Row.js